import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import SEO from '../components/SEO';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e.msg || JSON.stringify(e)).join(' '));
      else setError('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[#F9FAFB]">
      <SEO title="Admin Login" description="Ventriqo admin dashboard login." path="/admin/login" noindex />
      <div className="w-full max-w-md">
        <div className="bg-white border border-black/10 p-8">
          <h1 data-testid="admin-login-title" className="text-2xl font-black tracking-tighter text-black mb-1">Admin Login</h1>
          <p className="text-sm text-gray-500 mb-6">Sign in to manage your Ventriqo dashboard.</p>

          {error && (
            <div data-testid="admin-login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="admin-email" className="text-sm font-medium text-black">Email</Label>
              <Input
                data-testid="admin-login-email"
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="mt-1 rounded-[4px] border-black/20 focus:ring-2 focus:ring-[#002FA7]"
              />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-sm font-medium text-black">Password</Label>
              <Input
                data-testid="admin-login-password"
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="mt-1 rounded-[4px] border-black/20 focus:ring-2 focus:ring-[#002FA7]"
              />
            </div>
            <Button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#002FA7] hover:bg-[#002277] text-white rounded-[4px] py-3 text-sm font-semibold"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
